'use strict';

var StrategyClosureDirective = function StrategyClosureDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'StrategyClosureActionsController',
    template: require('../templates/strategy-closure-actions.html'),
    scope: {
      strategy: '='
    }
  };
};
StrategyClosureDirective.$inject = [];
module.exports = StrategyClosureDirective;